import script from "./ExamScoreModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamScoreModal.vue?vue&type=script&setup=true&lang=js"

import "./ExamScoreModal.vue?vue&type=style&index=0&id=7313a389&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7313a389"]])

export default __exports__